<template>
  <div>
    <global-details-popup :vModel="cancelModal">
      <v-container style="background-color: #ffffff !important">
        <global-cancel-popup
          :iconText="'Are you sure you would like to cancel the certificate request submission?'"
          :breadText="'All data entered will be lost upon cancellation'"
        >
          <template v-slot:closeCancel>
            <v-btn icon>
              <v-icon medium @click="cancelCancel">
                fa-light fa-xmark
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:cancelActions>
            <v-btn plain color="blue accent-4" @click="cancelCancel"
              >No</v-btn
            >
            <v-btn
              dark
              color="teal darken-2"
              elevation="0"
              @click="clearClicked()"
              >Yes</v-btn
            >
          </template>
        </global-cancel-popup>
      </v-container>
    </global-details-popup>
    <v-snackbar v-model="createdModal" top right color="#DBEBD2">
      <global-msg-alert
        iconColor="#487A7B"
        iconSize="2.5rem"
        icon="fa-solid fa-circle-check"
        textColor="color: #487A7B"
        type="Success"
        msg="Registration created successfully"
      />
    </v-snackbar>
    <v-snackbar v-model="errorModal" top right color="#FCE1D8">
      <global-msg-alert
        iconColor="#9D0E1C"
        iconSize="2.5rem"
        icon="fa-solid fa-circle-exclamation"
        textColor="color: #9D0E1C"
        type="Error"
        :msg="errorMsg"
      />
    </v-snackbar>
  </div>
</template>
<script>
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import GlobalCancelPopup from "@/components/global/global-cancel-popup.vue";

export default {
    props: ["cancel", "created", "showError", "errorMsg"],
    components: {
    GlobalMsgAlert,
    GlobalDetailsPopup,
    GlobalCancelPopup,
  },
  computed: {
    cancelModal:{
      get:function(){
        return this.cancel;
      },
      set:function(newVal){
        this.$emit("update:cancel", newVal)
      }
    },
    createdModal:{
      get:function(){
        return this.created
      },
      set:function(newVal){
        this.$emit("update:created", newVal)
      }
    },
    errorModal:{
      get:function(){
        return this.showError
      },
      set:function(newVal){
        this.$emit("update:showError", newVal)
      }
    }
  },
  methods: {
    cancelCancel(){
        this.$emit("cancelClicked", false)
    },
    clearClicked(){
      this.$emit("clearClicked")
    }
  },
};
</script>
<style></style>
